import Menu, { VerticalDirection, HorizontalDirection } from './Menu';
import SubMenu from './SubMenu';
import BackItem from './BackItem';
import HeaderItem from './HeaderItem';
import DividerItem from './DividerItem';
import IconMenu from './IconMenu';
import ItemPanel from './ItemPanel';
import PanelSelector from './PanelSelector';
import Item from './Item';

// Export enums
export { VerticalDirection, HorizontalDirection };

// Export components
export {
  Menu,
  SubMenu,
  BackItem,
  HeaderItem,
  DividerItem,
  IconMenu,
  ItemPanel,
  PanelSelector,
  Item,
};

// Namespace for components and enums
const AllInOneMenu = {
  Menu,
  SubMenu,
  BackItem,
  HeaderItem,
  DividerItem,
  IconMenu,
  ItemPanel,
  PanelSelector,
  Item,
  VerticalDirection,
  HorizontalDirection,
};

export default AllInOneMenu;
